var render, staticRenderFns
import script from "./coupon2N.vue?vue&type=script&lang=js"
export * from "./coupon2N.vue?vue&type=script&lang=js"
import style0 from "./coupon2N.vue?vue&type=style&index=0&id=151146c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151146c8",
  null
  
)

export default component.exports